import React from "react";
import { Zap } from "lucide-react";

export const PATHS = [
  "M0 80 H180 L220 120 H420",
  "M0 210 H120 L160 170 H300 L340 210 H520",
  "M60 340 H240 L280 300 H480",
  "M0 460 H200 L240 420 H360 L400 460 H600",
  "M300 0 V90 L340 130 V260",
  "M520 40 V160 L480 200 V360",
];

export function CircuitBg() {
  return (
    <>
      <div className="absolute inset-0 opacity-[.18] pointer-events-none" style={{ backgroundImage: "radial-gradient(#60a5fa 1px, transparent 1px)", backgroundSize: "26px 26px" }} />
      <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 600 520" preserveAspectRatio="xMidYMid slice" aria-hidden>
        {PATHS.map((d, i) => (
          <g key={i}>
            <path d={d} stroke="rgba(96,165,250,.18)" strokeWidth="1.5" fill="none" />
            <path d={d} className="current" stroke={i % 2 ? "#34d399" : "#60a5fa"} strokeWidth="2" fill="none" strokeLinecap="round" style={{ animationDelay: `${i * 0.5}s` }} />
          </g>
        ))}
      </svg>
    </>
  );
}

export function Logo3D() {
  return (
    <div className="scene relative w-[200px] h-[200px] sm:w-[240px] sm:h-[240px] grid place-items-center">
      <div className="absolute inset-[-28%] rounded-full bg-blue-500/25 blur-3xl glow-pulse" />
      <div className="float3d relative w-full h-full grid place-items-center">
        <div className="orbit orbit-a w-[160%] h-[160%]"><span className="spark" /><span className="spark s2" /></div>
        <div className="orbit orbit-b w-[132%] h-[132%] border-emerald-300/30"><span className="spark" style={{ background: "#93c5fd", boxShadow: "0 0 14px 4px rgba(147,197,253,.7)" }} /></div>
        <div className="orbit orbit-c w-[112%] h-[112%] border-blue-300/20"><span className="spark" style={{ background: "#fcd34d", boxShadow: "0 0 14px 4px rgba(252,211,77,.7)" }} /></div>
        <div className="logo3d relative w-[120px] h-[120px] sm:w-[140px] sm:h-[140px]">
          {[10, 8, 6, 4, 2].map((z) => (
            <div key={z} className="face bg-blue-950" style={{ transform: `translateZ(-${z * 2}px)` }} />
          ))}
          <div className="face bg-gradient-to-br from-blue-500 via-blue-700 to-blue-900 border border-blue-300/40 shadow-[0_30px_60px_-15px_rgba(30,64,175,.8)] grid place-items-center" style={{ transform: "translateZ(2px)" }}>
            <Zap className="bolt-flicker text-amber-300 drop-shadow-[0_0_18px_rgba(252,211,77,.85)]" size={64} fill="currentColor" strokeWidth={1.2} />
            <span className="absolute bottom-3 text-[10px] tracking-[.35em] text-blue-100 font-semibold">RANA</span>
          </div>
        </div>
      </div>
    </div>
  );
}
